import { render, staticRenderFns } from "./Q4.vue?vue&type=template&id=5235a60e&scoped=true&"
import script from "./Q4.vue?vue&type=script&lang=js&"
export * from "./Q4.vue?vue&type=script&lang=js&"
import style0 from "./Q4.vue?vue&type=style&index=0&id=5235a60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235a60e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VContainer,VTextField})
